import React, { useEffect, useRef, useState } from "react";
import CurrentMenuTable from '../../Components/Tables/CurrentMenuTable';
import axios from "axios";

interface Item {
  MenuID: number;
  menu_name: string;
  menu_page: string;
  menu_type: string;
  menu_index: number;
  // Add more properties as per your item structure
}

export default function Menus() {
  const [items, setItems] = useState<Item[]>([]);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const fetchData = async () => {
      try {
        const response = await axios.get('https://cdn.pulp.ph/api/user-menu', {
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (isMounted.current) {
          setItems(response.data.user_menu);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <React.Fragment>
      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="GraphikSemibold text-[20px] text-[#1f2328] font-semibold">List of Menus</h2>
        </div>

        <div className="flex flex-col">
          <CurrentMenuTable items={items as any} />
        </div>
      </div>
    </React.Fragment>
  );
}
